// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__Zax_j","form":"styles_form__1oz3Q"};